import React, {MouseEvent} from "react";
import ConfirmDialog from "./ConfirmDialog";
import {useTranslation} from "react-i18next";
import {get} from "lodash";
import {compose} from "redux";
import {withStyles} from "@material-ui/core";

interface Props {
    title?: string | JSX.Element | Array<JSX.Element>;
    content?: string | JSX.Element | Array<JSX.Element>;
    isOpen: boolean;
    onClose: (e: MouseEvent<HTMLButtonElement>) => void;
    onConfirm: (e: MouseEvent<HTMLButtonElement>) => void;
    record?: Record<string, any>;
}

interface InnerProps extends Props {
    classes: Record<string, string>;
}

const ConfirmDeleteDialog: React.FunctionComponent<InnerProps> = ({
                                                                      title,
                                                                      content,
                                                                      isOpen,
                                                                      onClose,
                                                                      onConfirm,
                                                                      record,
                                                                      classes
                                                                  }) => {
    const {t: translate} = useTranslation();
    const recordId = get(record, 'id');

    const dialogTitle = title || (
        <span className={classes.confirmDeleteDialogTitle}>
            {translate('components.defaultConfirmDeleteDialogTitle')}
        </span>
    );
    const dialogContent = content ||
        <span>{translate('components.defaultConfirmDeleteDialogContent', {id: recordId})}</span>;

    return (
        <ConfirmDialog
            title={dialogTitle}
            content={dialogContent}
            isOpen={isOpen}
            onClose={onClose}
            onConfirm={onConfirm}
        />
    );
};

export default compose(
    withStyles({
        confirmDeleteDialogTitle: {
            color: 'red'
        }
    })
)(ConfirmDeleteDialog);